const DEFAULT_S3_BUCKET = "techxeed-prod-data";
const DEFAULT_S3_HOST = `${DEFAULT_S3_BUCKET}.s3.us-east-1.amazonaws.com`;
const DEFAULT_S3_MEDIA_BASE_URL = "https://d28v02rpv54mir.cloudfront.net";

function configuredMediaBaseUrl(): string | null {
	const raw = process.env.NEXT_PUBLIC_S3_MEDIA_BASE_URL?.trim() || DEFAULT_S3_MEDIA_BASE_URL;
	if (!raw) return null;
	return raw.replace(/\/+$/, "");
}

export function getS3ObjectKeyFromUrl(rawUrl?: string | null): string | null {
	const trimmed = rawUrl?.trim();
	if (!trimmed) return null;

	try {
		const url = new URL(trimmed);
		const hostname = url.hostname.toLowerCase();
		const pathname = decodeURIComponent(url.pathname).replace(/^\/+/, "");
		const bucket = process.env.NEXT_PUBLIC_AWS_BUCKET_NAME || DEFAULT_S3_BUCKET;
		const region = process.env.NEXT_PUBLIC_AWS_REGION || "us-east-1";
		const bucketHosts = new Set([
			`${bucket}.s3.${region}.amazonaws.com`,
			`${bucket}.s3.amazonaws.com`,
			DEFAULT_S3_HOST,
		]);

		if (bucketHosts.has(hostname)) return pathname;
		if (hostname === "s3.amazonaws.com" && pathname.startsWith(`${bucket}/`)) {
			return pathname.slice(bucket.length + 1);
		}
		return null;
	} catch {
		return null;
	}
}

export function getPublicMediaUrl(rawUrl?: string | null): string | undefined {
	const trimmed = rawUrl?.trim();
	if (!trimmed) return undefined;
	try {
		const url = new URL(trimmed);
		if (url.search) return trimmed;
	} catch {
		if (trimmed.startsWith("//")) return `https:${trimmed}`;
		if (trimmed.startsWith("/") || trimmed.startsWith("data:") || trimmed.startsWith("blob:")) {
			return trimmed;
		}
		const mediaBaseUrl = configuredMediaBaseUrl();
		if (mediaBaseUrl) return `${mediaBaseUrl}/${encodeURI(trimmed.replace(/^\/+/, "")).replace(/%2F/g, "/")}`;
		return trimmed;
	}

	const key = getS3ObjectKeyFromUrl(trimmed);
	const mediaBaseUrl = configuredMediaBaseUrl();
	if (key && mediaBaseUrl) return `${mediaBaseUrl}/${encodeURI(key).replace(/%2F/g, "/")}`;

	return trimmed;
}

export function getVideoPlaybackUrl(rawUrl?: string | null): string | undefined {
	const publicUrl = getPublicMediaUrl(rawUrl);
	if (!publicUrl) return undefined;

	const key = getS3ObjectKeyFromUrl(rawUrl);
	if (key && !configuredMediaBaseUrl()) {
		return `/api/video-proxy?url=${encodeURIComponent(publicUrl)}`;
	}
	return publicUrl;
}
